(function(){
  var d = document;
  function ready(f){ if (d.readyState !== 'loading') { f(); } else { d.addEventListener('DOMContentLoaded', f); } }

  function payBadges(){
    var ic = d.querySelector('.payment-icons');
    if (!ic || d.querySelector('.rs-pay')) return;
    var wrap = d.createElement('div');
    wrap.className = 'rs-pay';
    var lbl = d.createElement('div');
    lbl.className = 'rs-pay__lbl';
    lbl.textContent = 'Secure card payments';
    wrap.appendChild(lbl);
    [['Visa', false], ['Mastercard', false]].forEach(function(p){
      var s = d.createElement('span');
      s.className = 'rs-pay__b' + (p[1] ? ' rs-pay__b--upi' : '');
      s.textContent = p[0];
      wrap.appendChild(s);
    });
    ic.parentNode.insertBefore(wrap, ic);
    ic.classList.add('rs-hide');
  }

  function spamNote(){
    var form = d.querySelector('.product-single__form');
    if (!form || d.querySelector('.rs-note')) return;
    var n = d.createElement('div');
    n.className = 'rs-note';
    n.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg><span>Your key is emailed within minutes. Can’t see it? Check your spam or promotions folder, or <a href="https://wa.me/917898057002" target="_blank" rel="noopener">message us on WhatsApp</a>.</span>';
    form.parentNode.insertBefore(n, form.nextSibling);
  }

  /* Product grids: show cards immediately instead of fading in blank while scrolling (theme scroll-animation + lazy images) */
  function steadyGrid(){
    var st = d.createElement('style');
    st.textContent = '.grid-product[data-aos]:not(.aos-animate){opacity:1 !important;transform:none !important}';
    d.head.appendChild(st);
    d.querySelectorAll('.grid-product img[loading="lazy"]').forEach(function(i){ i.setAttribute('loading', 'eager'); });
  }

  /* Smaller product images (like GMG / Eneba / G2A): 5 cards per row on desktop grids, a compact main image on product pages, and every card image the same size */
  function imageSizes(){
    var st = d.createElement('style');
    st.textContent = '.grid-product__image-mask .image-wrap{padding-bottom:120% !important;height:0 !important}' +
      '.grid-product__image-mask .image-wrap img,.grid-product__image-mask .image-wrap .image-element{object-fit:cover !important;width:100% !important;height:100% !important}' +
      '.grid-product__title{line-height:1.4;min-height:2.8em}' +
      '@media (min-width:769px){.grid-product__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}}' +
      '@media (min-width:1100px){' +
      '.grid--uniform>.grid__item.grid-product.medium-up--one-quarter{width:19.9% !important;clear:none !important}' +
      '.grid--uniform>.grid__item.grid-product.medium-up--one-quarter:nth-child(5n+1){clear:both !important}' +
      '.grid__item.medium-up--two-fifths:has(.product-image-main){width:31% !important}' +
      '.grid__item.medium-up--three-fifths:has(.product-single__meta){width:69% !important}' +
      '.product-single__meta{max-width:900px}' +
      '}' +
      '@media (max-width:768px){.product-image-main{max-width:300px;margin-left:auto;margin-right:auto}}';
    d.head.appendChild(st);
  }

  /* Desktop header: cart becomes a pill that shows the running total (CART when empty) */
  function headerActions(){
    var cart = d.querySelector('.site-header .js-drawer-open-cart');
    if (!cart) return;
    var t = null;
    function update(){
      fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(c){
        cart.setAttribute('data-rs-label', c.item_count > 0 ? '₹' + Math.round(c.total_price / 100).toLocaleString('en-IN') : 'CART');
      }).catch(function(){ cart.setAttribute('data-rs-label', 'CART'); });
    }
    function later(){ clearTimeout(t); t = setTimeout(update, 400); }
    cart.setAttribute('data-rs-label', 'CART');
    update();
    d.addEventListener('ajaxProduct:added', later);
    var drawer = d.querySelector('#CartDrawer');
    if (drawer) new MutationObserver(later).observe(drawer, { childList: true, subtree: true });
    var st = d.createElement('style');
    st.textContent = '@media (min-width:769px){' +
      '.site-header .js-drawer-open-cart{padding:6px 18px 6px 12px !important;border:1px solid rgba(232,17,45,.6);border-radius:999px;background:linear-gradient(145deg,#1a0508,#0d0d0d);transition:background .2s,border-color .2s,box-shadow .2s}' +
      '.site-header .js-drawer-open-cart:hover{background:#E8112D;border-color:#E8112D;box-shadow:0 0 18px rgba(232,17,45,.5)}' +
      '.site-header .js-drawer-open-cart:hover::after{color:#fff !important}' +
      '.site-header .js-drawer-open-cart::after{content:attr(data-rs-label) !important;margin-left:8px !important;font-size:15px !important}' +
      '.site-header .js-drawer-open-cart .cart-link__bubble{display:none !important}' +
      '.site-header .site-nav__link--icon.small--hide{margin-right:-10px !important}' +
      '}';
    d.head.appendChild(st);
  }

  /* Cart drawer: "You may also like" suggestions (Shopify recommendations API) with one-click add */
  function cartUpsell(){
    var drawer = d.querySelector('#CartDrawer');
    if (!drawer || drawer.__rsUp) return;
    drawer.__rsUp = 1;
    var busy = false, lastKey = '';
    function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function inr(c){ return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
    function wipe(){ var w = drawer.querySelector('.rs-up'); if (w) w.remove(); lastKey = ''; }
    function build(){
      if (busy) return;
      busy = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(cart){
        var items = cart.items || [];
        if (!items.length){ wipe(); busy = false; return; }
        var key = items.map(function(i){ return i.product_id; }).join(',');
        if (key === lastKey && drawer.querySelector('.rs-up')){ busy = false; return; }
        var inCart = {};
        items.forEach(function(i){ inCart[i.product_id] = 1; });
        return Promise.all(items.slice(0, 2).map(function(s){
          return fetch('/recommendations/products.json?product_id=' + s.product_id + '&limit=8&intent=related').then(function(r){ return r.json(); }).then(function(j){ return j.products || []; }).catch(function(){ return []; });
        })).then(function(lists){
          var seen = {}, recs = [], i = 0;
          while (recs.length < 3 && i < 8){
            lists.forEach(function(l){
              var p = l[i];
              if (p && !inCart[p.id] && !seen[p.id] && p.available && recs.length < 3){ seen[p.id] = 1; recs.push(p); }
            });
            i++;
          }
          var host = drawer.querySelector('.cart__items');
          if (!recs.length || !host){ if (!recs.length) wipe(); busy = false; return; }
          var old = drawer.querySelector('.rs-up');
          if (old) old.remove();
          var box = d.createElement('div');
          box.className = 'rs-up';
          box.innerHTML = '<div class="rs-up__h">You may also like</div>' + recs.map(function(p){
            var v = p.variants[0];
            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img && img.indexOf('//') === 0) img = 'https:' + img;
            return '<div class="rs-up__row"><a class="rs-up__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
              '<a class="rs-up__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="rs-up__p">' + inr(v.price) + '</span>' +
              '<button type="button" class="rs-up__add" data-v="' + v.id + '">+ Add</button></div>';
          }).join('');
          host.parentNode.insertBefore(box, host.nextSibling);
          lastKey = key;
          busy = false;
        });
      }).catch(function(){ busy = false; });
    }
    drawer.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.rs-up__add');
      if (!b || b.disabled) return;
      b.disabled = true;
      b.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(b.getAttribute('data-v'), 10), quantity: 1 }) })
        .then(function(r){ if (!r.ok) throw 0; return r.json(); })
        .then(function(item){ d.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } })); })
        .catch(function(){ b.disabled = false; b.textContent = '+ Add'; });
    });
    var t = null;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(build, 250); }).observe(drawer, { childList: true, subtree: true });
    var st = d.createElement('style');
    st.textContent = '.rs-up{margin:6px 20px 14px;padding:14px;border:1px solid rgba(232,17,45,.35);border-radius:12px;background:linear-gradient(145deg,#140006,#0d0d0d)}' +
      '.rs-up__h{font-family:Rajdhani,sans-serif;font-weight:700;font-size:13px;letter-spacing:1.6px;text-transform:uppercase;color:rgba(255,255,255,.55);margin:0 0 10px}' +
      '.rs-up__row{display:flex;align-items:center;gap:10px;padding:8px 0;border-top:1px solid rgba(255,255,255,.07)}' +
      '.rs-up__h + .rs-up__row{border-top:0}' +
      '.rs-up__img{flex:0 0 44px;width:44px;height:44px;border-radius:8px;overflow:hidden;background:#1a1a1c}' +
      '.rs-up__img img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.rs-up a,.rs-up a:hover{color:#fff !important;text-decoration:none !important}' +
      '.rs-up__t{flex:1;min-width:0;font-family:Rajdhani,sans-serif;font-weight:700;font-size:15px;line-height:1.2}' +
      '.rs-up__p{flex:0 0 auto;font-family:Rajdhani,sans-serif;font-weight:700;font-size:15px;color:#E8112D}' +
      '.rs-up__add{flex:0 0 auto;border:1px solid #E8112D;background:transparent;color:#fff;border-radius:6px;padding:6px 10px;font-family:Rajdhani,sans-serif;font-weight:700;font-size:13px;letter-spacing:1px;text-transform:uppercase;cursor:pointer;transition:background .15s}' +
      '.rs-up__add:hover{background:#E8112D}' +
      '.rs-up__add:disabled{opacity:.6;cursor:default}';
    d.head.appendChild(st);
    build();
  }

  /* Mobile search overlay: popular-search chips while the box is empty (the theme already suggests products once you type) */
  function mobileSearchChips(){
    var host = d.querySelector('.site-header__search .page-width');
    var input = d.querySelector('#Search');
    if (!host || !input || d.querySelector('.rs-mpop')) return;
    var pop = ['Roblox', 'Steam', 'Xbox', 'Nintendo', 'Valorant', 'Razer Gold', 'Minecraft'];
    var box = d.createElement('div');
    box.className = 'rs-mpop';
    box.innerHTML = '<div class="rs-mpop__lbl">Popular searches</div><div class="rs-mpop__chips">' + pop.map(function(t){ return '<a class="rs-mpop__chip" href="/search?type=product&q=' + encodeURIComponent(t) + '">' + t + '</a>'; }).join('') + '</div>';
    host.appendChild(box);
    function sync(){ box.style.display = input.value.trim().length < 1 ? 'block' : 'none'; }
    input.addEventListener('input', sync);
    var tg = d.querySelector('.js-search-header');
    if (tg) tg.addEventListener('click', function(){ setTimeout(sync, 60); });
    sync();
    var st = d.createElement('style');
    st.textContent = '.site-header__search .page-width{position:relative}' +
      '.site-header__search .rs-mpop{position:absolute;left:0;right:0;top:100%;height:calc(100vh - 70px);padding:16px 16px 18px;background:#0b0b0d;border-top:1px solid rgba(232,17,45,.3);z-index:5}' +
      '.rs-mpop__lbl{font-family:Rajdhani,sans-serif;font-weight:700;font-size:13px;letter-spacing:1.6px;text-transform:uppercase;color:rgba(255,255,255,.5);margin:0 0 10px}' +
      '.rs-mpop__chips{display:flex;flex-wrap:wrap;gap:8px}' +
      '.rs-mpop a.rs-mpop__chip,.rs-mpop a.rs-mpop__chip:hover{display:inline-block;padding:8px 16px;border:1px solid rgba(232,17,45,.5);border-radius:999px;background:#12090c;color:#fff !important;text-decoration:none !important;font-family:Rajdhani,sans-serif;font-weight:700;font-size:15px;letter-spacing:.8px}';
    d.head.appendChild(st);
  }

  /* Live product suggestions + popular searches under the desktop header search bar (Shopify predictive search endpoint) */
  function searchSuggest(form){
    var input = form.querySelector('input[type=search]');
    if (!input) return;
    var box = d.createElement('div');
    box.className = 'rs-sug';
    box.hidden = true;
    form.appendChild(box);
    var timer = null, ctrl = null, last = '';
    var popular = ['Roblox', 'Steam', 'Xbox', 'Nintendo', 'Valorant', 'Razer Gold', 'Minecraft'];
    function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function inr(v){ var n = Math.round(parseFloat(v)); return isNaN(n) ? '' : '₹' + n.toLocaleString('en-IN'); }
    function close(){ box.hidden = true; }
    function showPopular(){
      last = '';
      box.innerHTML = '<div class="rs-sug__pop"><div class="rs-sug__lbl">Popular searches</div><div class="rs-sug__chips">' +
        popular.map(function(t){ return '<a class="rs-sug__chip" href="/search?type=product&q=' + encodeURIComponent(t) + '">' + esc(t) + '</a>'; }).join('') +
        '</div></div>';
      box.hidden = false;
    }
    function render(q, items){
      if (!items.length){
        box.innerHTML = '<div class="rs-sug__empty">No products found for “' + esc(q) + '”. Try another name, e.g. Roblox, Steam, Xbox.</div>';
      } else {
        var html = items.map(function(p){
          return '<a class="rs-sug__row" href="' + esc(p.url) + '">' +
            '<span class="rs-sug__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="rs-sug__t">' + esc(p.title) + '</span>' +
            '<span class="rs-sug__p">' + inr(p.price) + '</span></a>';
        }).join('');
        html += '<a class="rs-sug__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a>';
        box.innerHTML = html;
      }
      box.hidden = false;
    }
    function run(){
      var q = input.value.trim();
      if (q.length < 2){ showPopular(); return; }
      if (q === last) { box.hidden = false; return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function(r){ return r.json(); })
        .then(function(j){
          if (input.value.trim() !== q) return;
          var items = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          render(q, items);
        })
        .catch(function(){});
    }
    input.addEventListener('input', function(){ clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', function(){ if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false; else showPopular(); });
    input.addEventListener('click', function(){ if (input.value.trim().length < 2) showPopular(); });
    input.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ close(); input.blur(); } });
    d.addEventListener('click', function(e){ if (!form.contains(e.target)) close(); });
  }

  /* Desktop header: logo on the left, a visible search bar in the middle, icons on the right */
  function headerSearch(){
    var lay = d.querySelector('.header-layout');
    if (!lay || d.querySelector('.rs-hsearch')) return;
    var logo = lay.querySelector('.header-item--logo');
    if (!logo) return;
    var item = d.createElement('div');
    item.className = 'header-item header-item--search';
    item.innerHTML = '<form class="rs-hsearch" action="/search" method="get" role="search"><input type="search" name="q" placeholder="Search Valorant, Roblox, Steam, Xbox..." aria-label="Search" autocomplete="off"><input type="hidden" name="type" value="product"><button type="submit" aria-label="Search"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg></button></form>';
    logo.parentNode.insertBefore(item, logo.nextSibling);
    searchSuggest(item.querySelector('form'));
    var lab = 'margin-left:9px;font-family:Rajdhani,sans-serif;font-weight:700;font-size:14px;letter-spacing:1.6px;color:rgba(255,255,255,.88);text-transform:uppercase;line-height:1';
    var st = d.createElement('style');
    st.textContent = '@media (min-width:769px){' +
      '.site-header{background:linear-gradient(180deg,#121214 0%,#0a0a0a 100%) !important;border-bottom:1px solid rgba(232,17,45,.4);box-shadow:0 8px 26px rgba(0,0,0,.55)}' +
      '.header-sticky-wrapper:has(.rs-sug:not([hidden])){z-index:50 !important}' +
      '.site-header .header-layout{display:flex !important;align-items:center;justify-content:flex-start !important;gap:28px;position:relative}' +
      '.site-header .header-layout .header-item{display:block !important;float:none !important;width:auto !important;flex:0 0 auto !important;margin:0 !important}' +
      '.site-header .header-layout .header-item--navigation{order:1}' +
      '.site-header .header-layout .header-item--logo{order:2;text-align:left !important;padding-left:30px !important}' +
      '.site-header .header-layout .header-item--logo img,.site-header .header-layout .header-item--logo svg{width:170px !important;max-width:170px !important;height:auto !important}' +
      '.site-header .header-layout .header-item--logo .site-header__logo{transform:translateY(-4px)}' +
      '.site-header .header-layout .header-item--search{position:absolute !important;left:50% !important;top:50% !important;transform:translate(-50%,-50%) !important;width:clamp(220px,calc(100vw - 800px),560px) !important;max-width:none !important;margin:0 !important;flex:none !important;z-index:60}' +
      '.site-header .header-layout .header-item--icons{order:4;margin-left:auto !important}' +
      '.site-header .js-drawer-open-nav{display:inline-flex !important;align-items:center}' +
      '.site-header .js-drawer-open-cart{display:inline-flex !important;align-items:center}' +
      '.site-header .js-drawer-open-nav::after{content:"MENU";' + lab + '}' +
      '.site-header .js-drawer-open-cart::after{content:"CART";' + lab + '}' +
      '.site-header .js-drawer-open-nav:hover::after,.site-header .js-drawer-open-cart:hover::after{color:#E8112D}' +
      '.rs-hsearch{position:relative;display:block;width:100%;height:46px}' +
      '.rs-hsearch input[type=search]{display:block;width:100%;height:46px;padding:0 54px 0 20px;background:#12090c;color:#fff;border:1px solid rgba(232,17,45,.5);border-radius:999px;font-family:Rajdhani,sans-serif;font-size:17px;outline:0;margin:0;box-shadow:inset 0 0 0 1px rgba(255,255,255,.03)}' +
      '.rs-hsearch input[type=search]:focus{border-color:#E8112D;box-shadow:0 0 16px rgba(232,17,45,.3)}' +
      '.rs-hsearch input[type=search]::placeholder{color:rgba(255,255,255,.5)}' +
      '.rs-hsearch button{position:absolute;right:5px;top:0;width:46px;height:46px;border:0;background:transparent !important;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;margin:0;box-shadow:none}' +
      '.rs-hsearch button svg{width:22px;height:22px;fill:none !important;stroke:#E8112D !important;stroke-width:2.4;stroke-linecap:round}' +
      '.rs-hsearch button svg *{fill:none !important;stroke:#E8112D !important}' +
      '.rs-hsearch button:hover svg,.rs-hsearch button:hover svg *{stroke:#ff3b55 !important}' +
      '.rs-sug{position:absolute;left:0;right:0;top:calc(100% + 8px);background:#0d0709;border:1px solid rgba(232,17,45,.55);border-radius:14px;box-shadow:0 18px 44px rgba(0,0,0,.7),0 0 22px rgba(232,17,45,.12);overflow:hidden;z-index:70}' +
      '.rs-sug[hidden]{display:none}' +
      '.rs-sug a,.rs-sug a:hover,.rs-sug a:focus{color:#fff !important;text-decoration:none !important}' +
      '.rs-sug__row{display:flex;align-items:center;gap:12px;padding:9px 14px;border-bottom:1px solid rgba(255,255,255,.06);transition:background .15s}' +
      '.rs-sug__row:hover{background:rgba(232,17,45,.14)}' +
      '.rs-sug__img{flex:0 0 46px;width:46px;height:46px;border-radius:8px;overflow:hidden;background:#1a1a1c}' +
      '.rs-sug__img img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.rs-sug__t{flex:1;min-width:0;font-family:Rajdhani,sans-serif;font-weight:700;font-size:17px;letter-spacing:.3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.rs-sug__p{flex:0 0 auto;font-family:Rajdhani,sans-serif;font-weight:700;font-size:17px;color:#E8112D}' +
      '.rs-sug__all{display:block;padding:11px 14px;text-align:center;font-family:Rajdhani,sans-serif;font-weight:700;font-size:14px;letter-spacing:1.2px;text-transform:uppercase;background:rgba(232,17,45,.12)}' +
      '.rs-sug__all:hover{background:#E8112D}' +
      '.rs-sug__empty{padding:16px 18px;color:rgba(255,255,255,.7);font-family:Rajdhani,sans-serif;font-size:16px}' +
      '.rs-sug__pop{padding:14px 16px 16px}' +
      '.rs-sug__lbl{font-family:Rajdhani,sans-serif;font-weight:700;font-size:13px;letter-spacing:1.6px;text-transform:uppercase;color:rgba(255,255,255,.5);margin:0 0 10px}' +
      '.rs-sug__chips{display:flex;flex-wrap:wrap;gap:8px}' +
      '.rs-sug__chip{display:inline-block;padding:7px 16px;border:1px solid rgba(232,17,45,.5);border-radius:999px;background:#12090c;font-family:Rajdhani,sans-serif;font-weight:700;font-size:15px;letter-spacing:.8px;transition:background .15s,border-color .15s}' +
      '.rs-sug__chip:hover{background:#E8112D;border-color:#E8112D}' +
      '.site-header .js-search-header{display:none !important}' +
      '}' +
      '@media (max-width:768px){.site-header .header-item--search{display:none !important}.site-header .header-layout{display:flex !important;align-items:center}.site-header .header-layout .header-item--navigation,.site-header .header-layout .header-item--icons{flex:1 1 0 !important;width:auto !important;min-width:0}.site-header .header-layout .header-item--logo{flex:0 0 auto !important;width:auto !important}.site-header .header-layout .header-item--icons{height:45px;display:flex !important;align-items:center;justify-content:flex-end}.site-header .site-nav,.site-header .site-nav__icons{line-height:0}.site-header .header-layout .header-item--navigation{text-align:left}.site-header .site-nav__icons{display:flex !important;align-items:center;gap:3px;height:45px;justify-content:flex-end}.site-header .site-nav__link--icon.small--hide{display:inline-flex !important;align-items:center;justify-content:center;order:2;width:37px !important;overflow:hidden;padding:7px 3px !important;margin:0 !important;line-height:0}.site-header .site-nav__link--icon.small--hide shopify-account{display:block;width:31px}.site-header .js-search-header{order:1;padding:7px 3px !important;margin:0 !important;transform:translateX(12px);line-height:0}.site-header .js-drawer-open-cart{order:3;padding:7px 3px !important;margin:0 !important;line-height:0}.site-header .site-nav__link--icon.small--hide svg,.site-header .js-search-header svg,.site-header .js-drawer-open-cart svg{width:31px !important;height:31px !important}' +
      '.promo-grid__container:has(.type-sale-images) .promo-grid__content{flex:0 0 42% !important;width:42% !important;box-sizing:border-box;min-width:0;min-height:122px;display:flex;flex-direction:column;justify-content:center}.promo-grid__container:has(.type-sale-images) .type-sale-images{flex:1 1 0 !important;min-width:0}}';
    d.head.appendChild(st);
  }

  ready(function(){ payBadges(); spamNote(); steadyGrid(); imageSizes(); headerActions(); cartUpsell(); mobileSearchChips(); headerSearch(); });
})();
